import styled from 'styled-components';

export const ItemImage = styled.div<{ $mask: string }>`
  background-color: ${({ theme }) => theme.color.s1};
  -webkit-mask-image: url(${({ $mask }) => $mask});
  mask-image: url(${({ $mask }) => $mask});
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: cover;
  mask-size: cover;
  width: 100%;
  height: 100%;
`;
